import { render, staticRenderFns } from "./serviceRequestReports.vue?vue&type=template&id=5b20e3a8&"
import script from "./serviceRequestReports.vue?vue&type=script&lang=js&"
export * from "./serviceRequestReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports